const createMongoSort = (fieldName: string | undefined, direction: string): string => `{ "${fieldName}" : ${direction === 'ASC' ? 1 : -1} }`;

export default createMongoSort;
